import { action as apiAction } from 'api/Api'
import {
  setListId,
  setPositions
} from 'routes/Board/redux/cards'
import { optimisticDispatch } from 'utils/sagas'
import sweetalert from 'sweetalert2'
import createSortedCardsInListSelector from 'routes/Board/selectors/createSortedCardsInListSelector'

type Payload = {
  cardId: number
  listId: number
}

const requestChangeCardList = (payload: Payload) => async (dispatch, getState) => {
  const { cardId, listId } = payload

  const state = getState()

  const cardsInList = createSortedCardsInListSelector(state => state['view-board'].cards[cardId].boardId, () => listId)(state)

  const optimisticAction = optimisticDispatch(dispatch, [
    setListId({
      id: cardId,
      listId
    }),
    setPositions([{
      id: cardId,
      position: listId ? (cardsInList[0] ? cardsInList[0].position - 100 : 1) : undefined,
    }])
  ])

  try {
    await apiAction('ChangeCardParent', {
      containerToId: listId,
      id: cardId,
      position: 'top',
    })

    optimisticAction.commit()
  } catch (error) {
    optimisticAction.revert()

    if (error.code === 539) { // Card is blocked
      try {
        await sweetalert({
          text: getState().kanbo.locale.messages['BLOCKERS_CARD_BLOCKED_ERROR'],
          type: 'info'
        })
      } catch (e) {}
    } else if (error.code !== 302) { // Source and target are the same
      throw error
    }
  }
}

export default requestChangeCardList
